import { memo } from 'react';
import styles from './m90-quote.module.css';
import Quote from '$icons/quote.svg';
import { Container } from '../container/container.component';
import { M90QuoteModule } from '~/lib/data-contract';
import { Button, MediaImage, Typography } from '~/shared/components';
import { queriesIsolated } from '~/theme/breakpoints';
import clsx from 'clsx';

type Props = M90QuoteModule;

const M90Quote = memo(({ quote, author, callToAction, image, ...rest }: Props) => {
    return (
        <Container hasGutter {...rest} className={styles.root}>
            {image?.src && (
                <div className={styles.imageWrapper}>
                    <MediaImage
                        src={image.src}
                        alt={image.alt || ''}
                        fill
                        cW={591}
                        cH={702}
                        sizes={`${queriesIsolated.xs} 100vw, ${queriesIsolated.sm} 50vw, 40vw`}
                        className={styles.image}
                    />
                </div>
            )}
            <div
                className={clsx(styles.content, {
                    [styles.withImage]: Boolean(image?.src),
                })}
            >
                <div className={styles.quote}>
                    <Quote />
                    <Typography variant="quote">{quote}</Typography>
                </div>
                {author && (
                    <Typography className={styles.author} as="p">
                        - {author}
                    </Typography>
                )}
                {callToAction?.url && (
                    <Button
                        href={callToAction.url}
                        variant="secondary"
                        target={callToAction.target}
                        hoverEffect
                        title={callToAction.title}
                        className={styles.button}
                    >
                        {callToAction.text}
                    </Button>
                )}
            </div>
        </Container>
    );
});

M90Quote.displayName = 'M90Quote';
export default M90Quote;
